import type { DistrictSchoolLevelType } from "@/providers/store/api/find-my-school/find-my-school.interface";

/** District school levels that may appear as Find My School map layers. Missing data hides all school layers. */
export function resolveFindMySchoolLayerTypes(
  types: readonly DistrictSchoolLevelType[] | undefined,
): readonly DistrictSchoolLevelType[] {
  return types ?? [];
}
